import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Estate from "@/pages/Estate";
import Weddings from "@/pages/Weddings";
import Retreats from "@/pages/Retreats";
import Gallery from "@/pages/Gallery";
import Enquire from "@/pages/Enquire";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/estate" element={<Estate />} />
          <Route path="/weddings" element={<Weddings />} />
          <Route path="/retreats" element={<Retreats />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/enquire" element={<Enquire />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1E1610", color: "#F4F1EA", border: "1px solid rgba(200,157,86,0.35)" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
